export const SPECIALTIES_ACTIONS = {
    FIND: 'FIND_SPECIALTIES',
    GET: 'GET_SPECIALTIES',
    GET_LIST: 'GET_SPECIALTIES_LIST',
    CHANGE_STATUS: 'CHANGE_STATUS_SPECIALTIES',
    SUCCESS: 'SUCCESS_SPECIALTIES',
    ERROR: 'ERROR_SPECIALTIES',
    CLEAN: 'CLEAN_SPECIALTIES',
}